import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {AuthenticationService} from '../../services/authentication.service';
import {HttpParams} from '@angular/common/http';
import * as _ from 'lodash';
import {SelectItem} from 'primeng/api';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {TemplateService} from '../../services/template.service';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {Subscription} from "rxjs";

@Component({
  selector: 'app-tax-report',
  templateUrl: './zip-file.component.html',
  styleUrls: ['./zip-file.scss'],
  providers: [TemplateService]
})
export class ZipFileComponent implements OnInit, OnDestroy {
  itemsPerPage = 40;
  filterVerifiedAccount: any;
  selectedVerifiedAccount: SelectItem[];
  allBranch = true;
  allDocType = true;
  notUploaded: any;
  branch: any;
  documentType: any;
  selectedValues = [];
  tableData: any;
  modal: NgbModalRef;
  currentPage = 1;
  totalItems: number;
  loading = false;
  loading_all_zip = false;
  cancel_loading_all_zip = false;
  loading_all_zip_message = '';
  no_data = true;
  value = 0;
  sum_docs_count = 0;
  loading_all_zip_progress = 0;
  errorMsg = '';
  monthListDropdown = [
    {label: 'มกราคม', value: 1},
    {label: 'กุมภาพันธ์', value: 2},
    {label: 'มีนาคม', value: 3},
    {label: 'เมษายน', value: 4},
    {label: 'พฤษภาคม', value: 5},
    {label: 'มิถุนายน', value: 6},
    {label: 'กรกฎาคม', value: 7},
    {label: 'สิงหาคม', value: 8},
    {label: 'กันยายน', value: 9},
    {label: 'ตุลาคม', value: 10},
    {label: 'พฤศจิกายน', value: 11},
    {label: 'ธันวาคม', value: 12}
  ];
  yearList: any[] = [];

  selectedMonth: any;
  selectedYear: any;

  allZipCount: number;
  allZipCurrent = 0;

  index = 0;
  tableArray = [];
  modalData: any;

  uploaded_row_count: 0;
  total_rows_count: 0;

  company = [];
  selectedCompany: SelectItem[];

  branchList = [];
  selectedBranch: SelectItem[];
  allBranchList: any = null;

  loading_excel_report = false;

  sortBy: string;
  sortMode: string;
  is_TH = false;

  rdDocumentType: any;
  selectedRdDocumentType: any;

  tableCol = [];

  subs: Subscription;

  @ViewChild('tt') table: any;

  constructor(private apiService: ApiService,
              private modalService: NgbModal,
              private authService: AuthenticationService,
              private template: TemplateService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.subs = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.populateDropdown();
    });
    this.populateDropdown();
    this.searchData();
  }

  get currentLang(): string {
    return this.translate.currentLang;
  }

  populateDropdown() {
    this.loadMonthYear();
    this.loadTableHeader();
    this.loadDocumentType();
    this.loadCompanyAndBranch();
    this.loadAccountVerifyDropdown();
  }

  loadMonthYear() {
    this.monthListDropdown = [
      {label: this.translate.instant('MONTH.JANUARY'), value: 1},
      {label: this.translate.instant('MONTH.FEBRUARY'), value: 2},
      {label: this.translate.instant('MONTH.MARCH'), value: 3},
      {label: this.translate.instant('MONTH.APRIL'), value: 4},
      {label: this.translate.instant('MONTH.MAY'), value: 5},
      {label: this.translate.instant('MONTH.JUNE'), value: 6},
      {label: this.translate.instant('MONTH.JULY'), value: 7},
      {label: this.translate.instant('MONTH.AUGUST'), value: 8},
      {label: this.translate.instant('MONTH.SEPTEMBER'), value: 9},
      {label: this.translate.instant('MONTH.OCTOBER'), value: 10},
      {label: this.translate.instant('MONTH.NOVEMBER'), value: 11},
      {label: this.translate.instant('MONTH.DECEMBER'), value: 12}
    ];
    const currentDate = new Date();
    // populate year list back within 10 years
    const thisYear = currentDate.getFullYear();
    for (let i = 0; i <= 10; i++) {
      this.yearList.push({label: (thisYear - i).toString(), value: thisYear - i});
    }

    // set current month and year
    this.selectedMonth = currentDate.getMonth() + 1;
    this.selectedYear = thisYear;
  }

  loadDocumentType() {
    const documentData = this.template.getDropdown();
    documentData[0] = {label: this.translate.instant('COMMON.ALL'), value: null};
    this.rdDocumentType = documentData;
    this.selectedRdDocumentType = null;
  }

  loadTableHeader() {
    this.tableCol = [
      {field: 'branch', header: this.translate.instant('TABLE.BRANCH-NAME')},
      {field: 'rd_doc_type', header: this.translate.instant('FILTER.DOCUMENT-TYPE')},
      {field: 'total_doc', header: this.translate.instant('TABLE.NUMBER-DOCUMENTS')},
    ];
  }

  loadCompanyAndBranch() {
    this.company = [];
    this.apiService.getCompany().subscribe(
      (result) => {
        this.company = [{
          label: this.translate.instant('COMMON.ALL'),
          value: null
        }]
        _.forEach(result, (obj) => {
          this.company.push({
            label: obj.name,
            value: obj.id
          });
        });
        this.selectedCompany = null;
      }
    );
    this.apiService.getBranch().subscribe(
      (result) => {
        this.allBranchList = result;
        this.filterBranchList();
      }
    );
  }

  loadAccountVerifyDropdown() {
    this.filterVerifiedAccount = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }, {
      label: this.translate.instant('ZIP-FILE.ONLY-VERIFIED-ACCOUNT'),
      value: true
    }, {
      label: this.translate.instant('ZIP-FILE.ONLY-UNVERIFIED'),
      value: false
    }];
  }

  canUserDownloadDoc() {
    return this.authService.isAccountantAdmin();
  }

  filterBranchList() {
    this.selectedBranch = null;

    this.branchList = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    _.forEach(this.allBranchList, (obj) => {
      if (this.selectedCompany == null || obj.corporate == this.selectedCompany) {
        this.branchList.push({
          label: obj.full_name,
          value: obj.id
        });
      }
    });
  }

  getProgress() {
    const progress = this.total_rows_count > 0 ? ((this.uploaded_row_count / this.total_rows_count) * 100.0) : 0;
    return Math.floor(progress);
  }

  pageChanged() {
    const params = new HttpParams().set('page', _.toString(this.currentPage));
    this.searchData(params);
  }

  searchData(params?) {
    this.loading = true;
    this.checkCondition();

    if (this.errorMsg.length > 0) {
      this.loading = false;
      return;
    }

    const data = {
      is_verified: this.selectedVerifiedAccount,
      not_uploaded_only: this.notUploaded,
      month: this.selectedMonth,
      year: this.selectedYear,
      company_id: this.selectedCompany,
      branch_id: this.selectedBranch ? this.selectedBranch : null,
      items_per_page: this.itemsPerPage,
      rd_doc_type: this.selectedRdDocumentType,
    };

    if (this.sortBy && this.sortMode) {
      data['sort'] = this.sortBy;
      data['sort_type'] = this.sortMode;
    }

    this.apiService.postSaleZipTax(data, params).subscribe(
      (result) => {
        this.loading = false;
        this.tableData = result.results;
        this.uploaded_row_count = result.uploaded_row_count;
        this.total_rows_count = result.total_rows_count;
        this.sum_docs_count = result.sum_docs_count;
        this.no_data = _.isEmpty(this.tableData);
        this.totalItems = result.count;

        this.selectedValues = [];
        for (let i = 0; i < this.tableData.length; i++)
          this.selectedValues.push(false);
      },
      error => {
        this.loading = false;
        this.no_data = true;
        this.errorMsg = this.translate.instant('ERROR.TRY-AGAIN');
      }
    );
  }

  searchButtonClicked() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    if (!this.no_data) {
      this.table.reset();
    }
    this.searchData();
  }

  confirm() {
    if (this.modalData.uploaded === false) {
      const params = {
        approved: true,
        month: this.selectedMonth,
        year: this.selectedYear,
        group: this.modalData.group,
        rd_document_type: this.modalData.rd_document_type,
        document_type: this.modalData.document_type,
        corporate_branch: this.modalData.corporate_branch,
      };
      this.apiService.approveUploadSale(params).subscribe(
        (result) => {
          this.modal.close();
        }
      );
    } else {
      const params = {
        approved: false,
        month: this.selectedMonth,
        year: this.selectedYear,
        group: this.modalData.group,
        rd_document_type: this.modalData.rd_document_type,
        document_type: this.modalData.document_type,
        corporate_branch: this.modalData.corporate_branch,
      };
      this.apiService.approveUploadSale(params).subscribe(
        (result) => {
          this.modal.close();
        }
      );
    }
  }

  revertBack() {
    this.searchData();
    this.modal.close();
  }

  clearData() {
    const currentDate = new Date();
    this.selectedMonth = currentDate.getMonth() + 1;
    this.selectedYear = currentDate.getFullYear();
    this.selectedCompany = null;
    this.selectedVerifiedAccount = null;
    this.branch = null;
    this.documentType = null;
    this.allDocType = true;
    this.allBranch = true;
    this.notUploaded = false;
    this.selectedBranch = null;
    this.selectedRdDocumentType = null;

    this.searchButtonClicked();
  }

  getExportDocs(data) {
    const params = {
      month: this.selectedMonth,
      year: this.selectedYear,
      document_type_id: data.document_type,
      rd_document_type: data.rd_document_type,
      branch_id: data.corporate_branch,
      group_id: data.group
    };

    data.loading_zip = true;
    this.apiService.getAllZipFile(params).subscribe(
      (obj) => {
        const filename = this.getZipFileName(data);
        this.sniff('DOWNLOAD_ZIP', filename);
        this.apiService.createDownloadFile(obj, filename);

        if (!data.uploaded)
          this.uploaded_row_count++;

        data.uploaded = true;
        data.loading_zip = false;
      },
      error => {
        data.loading_zip = false;
      }
    );
  }

  checkCondition() {
    this.errorMsg = '';

    const errorMsgList = [];
    if (_.isEmpty(this.branch) && this.allBranch === false) {
      errorMsgList.push(this.translate.instant('FILTER.BRANCH'));
    }

    if (_.isEmpty(this.documentType) && this.allDocType === false) {
      errorMsgList.push('Doc Type');
    }

    if (errorMsgList.length > 0) {
      this.errorMsg = this.translate.instant('COMMON.SPECIFY') + ' ' + errorMsgList.join(', ') + ' ' + this.translate.instant('COMMON.CORRECT');
    }
  }

  selectAll() {
    for (let i = 0; i < this.tableData.length; i++) {
      this.selectedValues[i] = (this.tableData[i].can_download_zip === true);
    }
  }

  deselectAll() {
    for (let i = 0; i < this.tableData.length; i++) {
      this.selectedValues[i] = false;
    }
  }

  canSelectAll() {
    return this.tableData.filter(data => data.can_download_zip === true).length > 0;
  }

  selectDeselectAll(checked) {
    if (checked) {
      this.selectAll();
      return;
    }
    this.deselectAll();
  }

  DownloadSelected(content) {
    this.tableArray = [];

    for (let i = 0; i < this.selectedValues.length; i++) {
      if (!this.selectedValues[i]) {
        continue;
      }
      this.tableArray.push(this.tableData[i]);
    }

    if (!_.isEmpty(this.tableArray)) {
      this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false, centered: true});
      this.allZipCount = this.tableArray.length;
      this.cancel_loading_all_zip = false;
      this.download(this.index, this.tableArray);
    }
  }

  EnabledDownloadSelected() {
    return this.selectedValues.filter(select => select == true).length > 0;
  }

  DownloadExcelReport() {
    this.loading_excel_report = true;

    const params = {
      month: this.selectedMonth,
      year: this.selectedYear,
    };
    this.apiService.getExcelReport(params).subscribe(
      (obj) => {
        const filename = 'tax_report_' + this.selectedMonth + '_' + this.selectedYear + '.xlsx';
        this.sniff('DOWNLOAD_XLS', filename);
        this.apiService.createDownloadFile(obj, filename);
        this.loading_excel_report = false;
      },
      error => {
        this.loading_excel_report = false;
      }
    );
  }

  download(index, tableArray) {
    this.loading_all_zip = true;

    if (index >= tableArray.length) {
      this.loading_all_zip = false;
      this.loading_all_zip_message = 'Download ' + this.translate.instant('COMMON.COMPLETE') + ' (' + this.translate.instant('FILTER.ALL') + ' ' + tableArray.length + ' ' + this.translate.instant('SEARCH.ITEMS') + ')';

      for (let i = 0; i < tableArray.length; i++) {
        if (!tableArray[i].uploaded)
          this.uploaded_row_count++;

        tableArray[i].uploaded = true;
      }

      return;
    }

    if (this.cancel_loading_all_zip) {
      return;
    }

    const params = {
      month: this.selectedMonth,
      year: this.selectedYear,
      document_type_id: tableArray[index].document_type,
      rd_document_type: tableArray[index].rd_document_type,
      branch_id: tableArray[index].corporate_branch,
      group_id: tableArray[index].group,
    };

    this.apiService.getAllZipFile(params).subscribe(
      (obj) => {
        if (this.cancel_loading_all_zip) {
          return;
        }

        const filename = this.getZipFileName(tableArray[index]);
        this.apiService.createDownloadFile(obj, filename);
        this.allZipCurrent++;
        this.loading_all_zip_progress = (this.allZipCurrent / this.allZipCount) * 100;
        setTimeout(() => {
          this.download(index + 1, tableArray);
        }, 1000);
      },
      error => {
        this.loading_all_zip = false;
        this.loading_all_zip_message = this.translate.instant('ERROR.TRY-AGAIN');
      }
    );
  }

  getZipFileName(data) {
    let file_name = '' + this.selectedMonth + '_' + this.selectedYear + '_' + data.branch__code + '_' + data.branch__rd_id + '_' + data.document_type__type;
    file_name = file_name.replace(/([^a-z0-9]+)/gi, '_');
    return file_name + '.zip';
  }

  closeDownloadAll() {
    this.modal.close();
    this.cancel_loading_all_zip = true;
    this.loading_all_zip = false;
    this.allZipCurrent = 0;
    this.loading_all_zip_progress = 0;
  }

  sort(event) {
    this.sortBy = event.field;
    if (event.order === 1) {
      this.sortMode = 'asc';
    } else {
      this.sortMode = 'desc';
    }
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'XML_PAGE',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/zip-file/zip-file.component.ts